<template>
  <p :class="['naj-error-text', `size-${size}`]">{{ text }}</p>
</template>

<script>
export default {
  name: 'naj-error-text',
  props: {
    text: {
      required: true,
    },
    size: {
      required: false,
      validator (value) {
        const validValues = {
          small: true,
          medium: true,
          large: true,
        };
        // the value must be one of valid values
        return validValues[value];
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/partials/_vars.scss';
.naj-error-text {
  color: #ff5252;
  &.size- {
    &small {
      font-size: 12px;
    }
    &medium {
      font-size: 16px;
    }
    &large {
      font-size: 20px;
    }
  }
}
</style>
